import type { Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MainComponent } from '@web/layout/main/main.component';
import { PageContentComponent } from '@web/layout/content/page-content/page-content.component';
import { AdminResolver } from '@web/core/resolvers/admin.resolver';
import { EcommerceResolver } from '@web/core/resolvers/ecommerce.resolver';

const routes: Routes = [
    {
        path: '',
        component: MainComponent,
    },
    {
        path: 'admin',
        component: MainComponent,
        children: [
            {
                path: ':templateId',
                component: PageContentComponent,
            },
        ],
        resolve: {
            admin: AdminResolver,
        },
    },
    {
        path: ':siteId',
        component: MainComponent,
        children: [
            {
                path: 'page/:pageId',
                component: PageContentComponent,
            },
            {
                path: 'ecommerce',
                component: PageContentComponent,
                resolve: {
                    mode: EcommerceResolver,
                },
            },
            { path: 'page', component: PageContentComponent },
        ],
    },
];

@NgModule({
    declarations: [],
    imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
